import PropTypes from 'prop-types';

export const MAIN_SIGNIN_PATH = '/signin';
export const CREATE_ACCOUNT_GA_CATEGORY = 'Create Account';
export const CREATE_ACCOUNT_FORM_ROOT_KEY = 'createAccountForm';

export const AccountType = {
    Default: 'default',
    Google: 'google',
    Facebook: 'facebook',
    Apple: 'apple',
};

export const Gender = {
    Female: 'Female',
    Male: 'Male',
};

export const SocialUserDetailsParsedPropType = PropTypes.shape({
    accountType: PropTypes.oneOf([
        AccountType.Default,
        AccountType.Google,
        AccountType.Facebook,
        AccountType.Apple,
    ]).isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    dateOfBirth: PropTypes.date,
    gender: PropTypes.oneOf([
        Gender.Female.toLowerCase(),
        Gender.Male.toLowerCase(),
        null,
    ]),
    email: PropTypes.string,
    userIdToken: PropTypes.string.isRequired,
});

export const SocialUserDetailsPropType = PropTypes.shape({
    account_type: PropTypes.oneOf([
        AccountType.Default,
        AccountType.Google,
        AccountType.Facebook,
        AccountType.Apple,
    ]).isRequired,
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
    date_of_birth: PropTypes.string, // MM\/dd\/yyyy string format,  could be null
    gender: PropTypes.oneOf([Gender.Female, Gender.Male, null]),
    email: PropTypes.string,
    user_id_token: PropTypes.string.isRequired,
});
